import NodeWebSocket from "ws";
import { ITransport, ITransportEventMap } from "./ITransport";

// const WebSocket = globalThis.WebSocket || NodeWebSocket;

export class MPSocketTransport implements ITransport {
    ws: WebSocket | NodeWebSocket | any;
    protocols?: string | string[];

    constructor(public events: ITransportEventMap) {}

    public send(data: ArrayBuffer | Array<number>): void {
        if (data instanceof ArrayBuffer) {
            this.ws.send({ data });
        } else if (Array.isArray(data)) {
            this.ws.send({ data: new Uint8Array(data).buffer });
        }
    }

    public connect(url: string) {
        // console.log(this.ws);

        this.ws = wx.connectSocket({
            url,
            // header: {
            //     'content-type': 'application/json'
            // },
            protocols: this.protocols,
            // method: 'GET'
        });

        this.ws.onMessage((msg) => {
            // console.log("msg", msg);
            this.events.onmessage(msg);
        });

        this.ws.onClose((msg) => {
            console.log("close", msg);
            this.events.onclose(msg);
        });

        this.ws.onError((msg) => {
            console.log("error", msg);
            this.events.onerror(msg);
        });

        // console.log(this.ws);

        // this.ws.binaryType = "arraybuffer";
        // this.ws.onopen = this.events.onopen;
        // this.ws.onmessage = this.events.onmessage;
        // this.ws.onclose = this.events.onclose;
        // this.ws.onerror = this.events.onerror;
    }

    public close(code?: number, reason?: string) {
        console.log("关闭连接");

        this.ws.close(code, reason);
    }
}
